import { LatestTrace } from "../types";
import { AbstractStore, StorePartialTrace } from "./AbstractStore";

export class InlinePageStore {
    private latestTime: number;

    private latestTrace: LatestTrace;

    setItem(item: LatestTrace): void {
        this.latestTrace = item;
        this.latestTime = Date.now();
    }

    getItem(): StorePartialTrace {
        const trace = AbstractStore.adaptTrace(
            this.latestTime,
            this.latestTrace
        );

        this.latestTime = 0;

        return trace;
    }
}
